import Vue from 'vue'
import { Input, Button, Table, Select, Descriptions, Icon, Upload, Drawer, DatePicker, Progress } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
Vue.config.productionTip = false

/* v1.1.3+ 自动注册Button下组件，如Button.Group */
Vue.use(Input)
Vue.use(Button)
Vue.use(Table)
Vue.use(Select)
Vue.use(Descriptions)
Vue.use(Icon)
Vue.use(Upload)
Vue.use(Drawer)
Vue.use(DatePicker)
Vue.use(Progress)
